import { render, staticRenderFns } from "./s-solde-list-item.vue?vue&type=template&id=0fb6c2f5"
import script from "./s-solde-list-item.vue?vue&type=script&setup=true&lang=js"
export * from "./s-solde-list-item.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports